import {
	AirlineStore,
	AirportStore,
	FlightDetailStore,
	FlightStore,
} from '@move-frontend/dap';
import { IFlight } from './flight/domain/models/IFlight';
import { dap } from '../../shared/api/dap';
import { createFlightEnrichStore } from './flight/domain/stores/createFlightEnrichStore';
import { createFlightListStore } from '../overview/domain/stores/createFlightListStore';
import { createFlightSuggestionStore } from '../search/domain/stores/createFlightSuggestionStore';

export type IFlightsStores = ReturnType<typeof createFlightStores>;

export function createFlightStores() {
	const flightStore = new FlightStore<IFlight>(dap);
	const airlineStore = new AirlineStore();
	const airportStore = new AirportStore();

	const flightEnrichStore = createFlightEnrichStore(airlineStore, airportStore);
	const flightListStore = createFlightListStore(flightStore, flightEnrichStore);
	const flightSuggestionStore = createFlightSuggestionStore(
		flightStore,
		airlineStore,
		airportStore,
	);

	const flightDetailStore = new FlightDetailStore(flightEnrichStore, dap);

	return {
		airlineStore,
		airportStore,
		flightStore,
		flightListStore,
		flightSuggestionStore,
		flightDetailStore,
	};
}
